import { createFileRoute } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { SettingsDirectoryPage } from "@/settings/SettingsDirectoryPage";
import { platformGroups } from "@/settings/settingsDirectory";

export const Route = createFileRoute("/_authenticated/platform-management")({
  component: PlatformManagementPage,
});

function PlatformManagementPage(): ReactNode {
  return (
    <SettingsDirectoryPage
      title="Platformbeheer"
      description="Beheer platformbrede gegevens en interne ontwikkelaarstools."
      searchLabel="Zoek in platformbeheer"
      groups={platformGroups}
    />
  );
}
